<template>
    <div class="footer">
      <div class="dsc">
          <span>{{footercom.data.producer}}</span> 
          <span style="margin-left:20px;">策划：符百芳</span> 
          <span style="margin-left:20px;">设计：洪静</span>
          <span style="margin-left:20px;">{{footercom.data.technology}}</span><br/>
          <span>{{footercom.data.copyright}}</span>
      </div>

    </div>
</template>
<script>
import axios from 'axios'
import {inject,reactive,onMounted} from 'vue'
export default {
    name:'Footer',
    setup(){
        let footercom=reactive({
            data:{
                "producer": "",
                "planner": "",
                "design": "",
                "technology": "",
                "copyright": "Copyright www.zgfznews.com All Rights Reserved 抚州市融媒体中心版权所有"
            }
        })
        let ztreq=inject('ztreq')
        onMounted(()=>{
                axios.get(ztreq.data.footurl).then((res)=>{
                footercom.data = res.data
            });
        });
        return{
            footercom
        }
    }

}
</script>
<style scoped>
.footer .dsc{
    background-color: white;
}
.footer{
    width: 1200px;
    color: #889;
    margin: 20px auto;
    text-align: center;
}
.footer-img{
    width:100%;
    height:580px;
    min-width: 1200px;
}
</style>